/* 4Spray - product image lightbox close button (added 2026-09-25)
   The custom product sections (comma, with-b-*, singlecomma42800) ship the
   lightbox <product-modal> without the theme's close button, so on touch
   devices there was no way to dismiss it (mouse users can click anywhere).
   This adds the button to any product lightbox that lacks one, and repairs
   the two sections whose button rendered a "Liquid error" instead of an icon. */
(function () {
  /* v2 2026-09-25: show each enlarged image whole, fitted to the screen, instead of at
     the theme's fixed 1100px width (which cropped it and needed scrolling both ways). */
  var FIT_CSS =
    ".product-media-modal-content{padding:2rem 6rem !important}" +
    ".product-media-modal-content>img{width:100% !important;height:auto !important;max-width:100% !important;" +
    "max-height:calc(100vh - 4rem) !important;object-fit:contain;margin:0 auto !important}" +
    ".product-media-modal-content>*{scroll-margin-top:2rem}" +
    ".product-media-modal-content>*+*{margin-top:2rem !important}" +
    "@media (max-width:749px){.product-media-modal-content{padding:6rem 1rem 1rem 1rem !important}" +
    ".product-media-modal-content>img{max-height:calc(100vh - 7rem) !important}}";
  if (!document.getElementById("pm-fit-css")) {
    var st = document.createElement("style");
    st.id = "pm-fit-css";
    st.textContent = FIT_CSS;
    document.head.appendChild(st);
  }

  var ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" ' +
    'stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="icon icon-x" aria-hidden="true">' +
    '<path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M18 6l-12 12"/><path d="M6 6l12 12"/></svg>';

  function fix(modal) {
    if (modal.dataset.closeFixed) return;
    modal.dataset.closeFixed = "1";
    var dialog = modal.querySelector(".product-media-modal-dialog") || modal;
    var btn = modal.querySelector('[id^="ModalClose-"]');
    if (btn) {
      if (/Liquid error/i.test(btn.textContent)) btn.innerHTML = ICON;
      return; // the theme already wired this button in ModalDialog's constructor
    }
    btn = document.createElement("button");
    btn.type = "button";
    btn.id = "ModalClose-" + (modal.id || "").replace(/^ProductModal-/, "");
    btn.className = "product-media-modal-toggle";
    btn.setAttribute("aria-label", "Close");
    btn.innerHTML = ICON;
    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      if (typeof modal.hide === "function") modal.hide();
    });
    dialog.insertBefore(btn, dialog.firstChild);
  }

  function run() {
    document.querySelectorAll("product-modal.product-media-modal").forEach(fix);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
  else run();
  // sections re-rendered by the theme editor / variant changes
  document.addEventListener("shopify:section:load", run);
})();
